<template>
  <div>
    <a-form>
      <a-form-item label="Passord">
        <a-input type="password" v-model="pwd"></a-input>
      </a-form-item>
      <a-form-item label="Confirm Password">
        <a-input type="password" v-model="confirm"></a-input>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="submit" style="margin: 10px">提交</a-button>
        <!-- <a-button type="primary" @click="create" style="margin: 10px">Create</a-button> -->
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import userinfo from "../utils/userinfo.js";

export default {
  data() {
    return {
      pwd: "",
      confirm: "",
    };
  },
  mounted: () => {},

  methods: {
    // create() {
    //   this.$http.post(this.$store.state.base_url + "/user/c", {
    //     account: "Daisy",
    //     name: "Daisy",
    //     group: "book-keeper",
    //     password: "yxychxr",
    //     confirm: "yxychxr",
    //   });
    // },
    submit() {
      this.$http
        .post(this.$store.state.base_url + "/user/u", {
          id: userinfo.get().user_id,
          password: this.pwd,
          confirm: this.confirm,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.info(res.data.msg);
          }
        });
    },
  },
};
</script>
<style scoped></style>
